export const FAQS = [
  {
    q: "How can Travel Passport and Visa LLC help with a passport?",
    a: "We provide professional assistance with passport applications and related documentation. Our team helps you understand current requirements, organize your materials, review your paperwork for completeness, and navigate the applicable government process. Travel Passport and Visa LLC is a private service provider — eligibility and issuance decisions are made by the U.S. Department of State.",
  },
  {
    q: "Do you assist with passport renewals?",
    a: "Yes. We assist with passport renewals, including helping you determine which renewal process applies to your situation, organizing required documents and photos, and reviewing your application materials before submission.",
  },
  {
    q: "Can you help with urgent travel-document needs?",
    a: "Yes, we assist travelers with urgent needs. Available options depend on the applicable government process, your travel date, and your eligibility. Urgent passport services typically involve processes administered by the U.S. Department of State, and we help you understand and navigate the options that may be available to you. Processing times are never guaranteed.",
  },
  {
    q: "Do you assist with visa applications?",
    a: "Yes. We assist with visa application documentation for many destinations, including tourist and business visas. Each embassy or consulate sets its own requirements, forms, fees, and processing times, and we help you prepare materials that align with those requirements.",
  },
  {
    q: "Do you work with business travelers?",
    a: "Yes. We regularly assist companies, executives, employees, consultants, and international teams with passport, visa, and travel-document needs. Contact us to discuss support for your organization's travelers.",
  },
  {
    q: "What fees will I have to pay?",
    a: "There are two types of fees. Government fees are charged by the applicable government agency or consulate and are paid to the government. Our service fees are separate and cover the professional assistance provided by Travel Passport and Visa LLC. We explain both clearly before you move forward.",
  },
  {
    q: "How long does passport processing take?",
    a: "Processing times are set by the U.S. Department of State and vary based on application type, eligibility, service level, and current processing conditions. Any estimated timeframe is subject to change and is not guaranteed. We can explain current estimated timeframes when you contact us.",
  },
  {
    q: "How long does visa processing take?",
    a: "Visa processing times are determined by each embassy or consulate and vary by destination, visa category, and current conditions. Estimated timeframes are subject to change and cannot be guaranteed.",
  },
  {
    q: "Can you guarantee my passport or visa will be approved?",
    a: "No. No private company can guarantee approval. Eligibility, processing, appointment, and approval decisions are made solely by the applicable government agency or consulate. Our role is to provide professional assistance with your documentation and application materials.",
  },
  {
    q: "Are you a government agency?",
    a: "No. Travel Passport and Visa LLC is a private service provider. Government agencies make their own eligibility, processing, appointment, and approval decisions. We are not affiliated with, endorsed by, or sponsored by the U.S. Department of State or any other government entity.",
  },
  {
    q: "Can I apply directly through the government?",
    a: "Yes. You can always apply directly through the U.S. Department of State or the applicable embassy or consulate, paying only the government fees. Many travelers choose our professional assistance to save time, reduce errors, and get help navigating documentation requirements.",
  },
  {
    q: "What information should I provide to get started?",
    a: "To get started, share your name, contact information, approximate travel date, destination country, and the service you need help with. You can submit the form on this page or call our team at 866-334-8472.",
  },
];
